import BaseModel from '@core/model';

import BillingGroupApi from '@packages/rate-plans/billing-groups/api';

import Investor from '@/models/Investor';

export class BillingGroup extends BaseModel {
    static name = 'BillingGroup';
    static entity = 'billingGroups';
    static Api = BillingGroupApi;

    static fields() {
        return {
            ...super.fields(),
            id: this.attr(null),
            name: this.string(null).nullable(),
            investor_id: this.string(null).nullable(),
            adviser_id: this.string(null).nullable(),
            investors_count: this.number(null).nullable(),
            investors: this.modelList(Investor, []),
            aggregate_aua: this.attr(this.defaultMoney).nullable(),
            aggregate_quantity: this.number(null).nullable(),
            aggregate_aua_eis: this.attr(this.defaultMoney).nullable(),
            aggregate_quantity_eis: this.number(null).nullable(),
            aggregate_aua_vct: this.attr(this.defaultMoney).nullable(),
            aggregate_quantity_vct: this.number(null).nullable(),
            aggregate_aua_iht: this.attr(this.defaultMoney).nullable(),
            aggregate_quantity_iht: this.number(null).nullable(),
            aggregate_aua_pmi: this.attr(this.defaultMoney).nullable(),
            aggregate_quantity_pmi: this.number(null).nullable(),
            active_subscriptions: this.attr([]).nullable()
        };
    }

    get has_multiple_investors() {
        if (typeof this.investors_count === 'number') {
            return this.investors_count > 1;
        }

        return Array.isArray(this.investors) && this.investors.length > 1;
    }

    static mock(overrides = {}) {
        return {
            id: faker => faker.string.uuid(),
            name: faker => faker.person.fullName(),
            investor_id: faker => overrides.investor_id || faker.string.uuid(),
            adviser_id: faker => overrides.adviser_id || faker.string.uuid(),
            investors_count: faker => faker.number.int({ min: 1, max: 3 }),
            aggregate_aua: () => ({ amount: 100000, currency: 'GBP' }),
            aggregate_quantity: () => 2,
            aggregate_aua_eis: () => null,
            aggregate_quantity_eis: () => null,
            aggregate_aua_vct: () => null,
            aggregate_quantity_vct: () => null,
            aggregate_aua_iht: () => null,
            aggregate_quantity_iht: () => null,
            aggregate_aua_pmi: () => null,
            aggregate_quantity_pmi: () => null,
            active_subscriptions: faker => {
                const adviserId = overrides.adviser_id || faker.string.uuid();

                return [
                    {
                        start_date: '2024-01-01',
                        end_date: null,
                        rate_plan_type: 'ADVISER',
                        rate_plan: {
                            id: `adviser-plan-${adviserId}`,
                            name: 'Inherited adviser plan',
                            status: 'ACTIVE',
                            type: 'ADVISER',
                            default: false,
                            adviser_id: adviserId
                        }
                    },
                    {
                        start_date: '2024-01-01',
                        end_date: null,
                        rate_plan_type: 'PLATFORM',
                        rate_plan: {
                            id: `platform-plan-${adviserId}`,
                            name: 'Inherited platform plan',
                            status: 'ACTIVE',
                            type: 'PLATFORM',
                            default: false,
                            adviser_id: adviserId
                        }
                    }
                ];
            }
        };
    }
}

export default BillingGroup;
